<div class="project-duration">
  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Organization Filter -->
        <div class="filter-item">
          <label>Organization</label>
          <ng-select
            [items]="organizationOptions"
            bindLabel="name"
            bindValue="name"
            placeholder="Select organization"
            [(ngModel)]="selectedOrganization"
            (change)="onOrganizationChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Matter Filter -->
        <div class="filter-item">
          <label>Matter</label>
          <ng-select
            [items]="matterOptions"
            bindLabel="name"
            bindValue="name"
            [placeholder]="selectedOrganization ? 'Select matter' : 'Select org first'"
            [(ngModel)]="selectedMatter"
            (change)="onMatterChange($event)"
            [clearable]="true"
            [disabled]="!selectedOrganization"
            class="custom-select multiline-dropdown">
            <ng-template ng-notfound-tmp>
              <div class="ng-option disabled">
                {{ selectedOrganization ? 'No matters found' : 'Please select an organization first' }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <!-- Project Filter -->
        <div class="filter-item">
          <label>Project</label>
          <ng-select
            [items]="projectOptions"
            bindLabel="name"
            bindValue="name"
            [placeholder]="selectedMatter ? 'Select project' : 'Select matter first'"
            [(ngModel)]="selectedProject"
            (change)="onProjectChange($event)"
            [clearable]="true"
            [disabled]="!selectedMatter"
            class="custom-select multiline-dropdown">
            <ng-template ng-notfound-tmp>
              <div class="ng-option disabled">
                {{ selectedMatter ? 'No projects found' : 'Please select a matter first' }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <!-- LPC Filter -->
        <div class="filter-item">
          <label>LPC</label>
          <ng-select
            [items]="lpcOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select LPC"
            [(ngModel)]="selectedLPC"
            (change)="onLPCChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Project Type Filter -->
        <div class="filter-item">
          <label>Project Type</label>
          <ng-select
            [items]="projectTypeOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select project type"
            [(ngModel)]="selectedProjectType"
            (change)="onProjectTypeChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="clearFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div #chartContainer class="chart-container">
        @if (isLoading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }

        @if (error) {
          <div class="alert alert-danger">
            {{ error }}
          </div>
        }

        @if (!isLoading && !error && data.length > 0) {
          <ngx-charts-bar-vertical-2d
            [view]="view"
            [scheme]="colorScheme"
            [results]="data"
            [gradient]="false"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            [noBarWhenZero]="true"
            [roundEdges]="false"
            [legendPosition]="legendPosition"
            (select)="onSelect($event)">
          </ngx-charts-bar-vertical-2d>
        }

        @if (!isLoading && !error && data.length === 0) {
          <div class="no-data-message">
            No project duration data available for the selected filters.
          </div>
        }
      </div>
    </div>
  </div>
</div>
